/**
 * How a house inside a business unit is named to a reader: "Rowohlt ·
 * Holtzbrinck Buchverlage" (ADR 0025).
 *
 * Both halves are load-bearing, which is why this is one rule and not a
 * judgement each surface makes. The house is the scope of whatever is being
 * labelled — a conclusion it reached, the pages its admin is on — and the unit
 * is what fixes *which* Rowohlt it is, because a house id is unique only inside
 * its unit and two units may each have a Fischer.
 *
 * Used by the group's product view, where a reviewer has to see whose position
 * a verdict is, and by the admin shell's context chip, where naming the unit
 * alone told a house's admin they were administering something the rules
 * refuse them.
 */
export function scopeLabel(
  unitName: string,
  /** The house's display *name*, never its id — an id on screen is worse than
   *  the unit's name alone, so a caller that has not resolved one yet passes
   *  nothing and gets the unit. */
  houseName: string | null | undefined,
): string {
  return houseName ? `${houseName} · ${unitName}` : unitName;
}
